import { isElementOutOfViewport } from "./HelperFunctions";

export const showStickyApply = () => {
    const body = document.querySelector<HTMLElement>(".job-details");
    const stickyApply = document.querySelector<HTMLElement>(".sticky-apply"); 
    const hero = document.querySelector<HTMLElement>(".job-details__hero");

    if (!body || !stickyApply || !hero) return;

    document.addEventListener("scroll", () => {
        const viewPortCheck = hero ? isElementOutOfViewport($(hero)[0]) : false;

        switch (true) {
            case viewPortCheck:
                stickyApply?.classList.add("sticky-apply--visible");
                break;
                
            default:
                stickyApply?.classList.remove("sticky-apply--visible");
                break;
        }
    });
};
